export default __webpack_public_path__ + "static/media/55_mobile.978263ba.jpg";